import type { Proposal } from "../types/proposal.types";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export const generateProposalPDF = async (
  proposal: Proposal,
  returnBlob = false
): Promise<Blob | void> => {
  try {
    const doc = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: "a4",
      compress: true,
    });

    const pages = [
      "cover",
      "main",
      "services",
      "service",
      "whatsapp",
      "stream",
      "agreement",
    ];

    for (let i = 0; i < pages.length; i++) {
      const element = document.getElementById(`${pages[i]}-page-pdf`);

      if (!element) continue;

      await new Promise((r) => setTimeout(r, 50));

      const canvas = await html2canvas(element, {
        scale: 1,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.75);

      if (i > 0) doc.addPage();

      doc.addImage(imgData, "JPEG", 0, 0, 210, 297, undefined, "FAST");
    }

    if (returnBlob) {
      return doc.output("blob");
    }

    doc.save(
      `proposal-${
        proposal.eventTitle || proposal.deceasedName || "document"
      }.pdf`
    );
  } catch (err) {
    console.error("[PDF] Generation failed:", err);
    throw err;
  }
};
